export default "__VITE_PUBLIC_ASSET__b2a787ca__"